<script>
  import { onMount } from 'svelte';
  import Hls from 'hls.js'

  import { styleVars } from '/helper'

  export let zIndex;
  export let blur = false;
  export let playing = false;
  export let black = false
  
  const bgImage = process.env.STILL_IMAGE_URL || "/assets/images/still.jpg"
  const bgStreamStatusUrl = process.env.STILL_IMAGE_URL ? bgImage.substr(bgImage, bgImage.lastIndexOf("/")) + "/status" : null

  let backdropFilter, backdropOpacity, prevPlaying
  let videoplayer, hls

  $: {
    backdropFilter = blur ? "blur(10px)" :  "none"
    backdropOpacity = blur ? 1 : 1
    // console.log(playing)
    if (typeof(prevPlaying) !== "undefined") {
      if (playing) play()
      else pause()
    }

    prevPlaying = playing
  }
  
  export function pause() {
    videoplayer.pause()
    if (hls) hls.stopLoad()
  }

  function play() {
    videoplayer.play()
    if (hls) hls.startLoad()
  }

  async function validateStreamStatus() {
    if (!bgStreamStatusUrl) return false
    return await fetch(bgStreamStatusUrl)
      .then(r => r.json())
      .then(data => {
        //console.log(data, data != "0" )
        return data != "0"
      });
  }

  onMount(async () => {
    //setTimeout(()=>{player.play();}, 2000)
    //player.setVolume(0);
    //vjs = videojs(videoplayer)
    //vjs.play();

    const streamIsOkay = await validateStreamStatus()

    if (!streamIsOkay) {
      console.log("stream seems to be malfunctioning, not initiating stream")
    }

    var videoSrc = process.env.STREAM_URL;
    if (Hls.isSupported() && streamIsOkay && videoSrc) {
      hls = new Hls({
        autoStartLoad: true,
        maxLoadingDelay: 2, // sec
        maxStarvationDelay: 2, // sec
        maxMaxBufferLength: 10, // sec
        maxBufferSize: 1 * 1000 * 1000 // bits

      });

      hls.on(Hls.Events.ERROR, function (event, data) {
        console.warn("HLS error", event, data)
      });

      hls.loadSource(videoSrc);
      hls.attachMedia(videoplayer);

    }    
    // hls.js is not supported on platforms that do not have Media Source
    // Extensions (MSE) enabled.
    //
    // When the browser has built-in HLS support (check using `canPlayType`),
    // we can provide an HLS manifest (i.e. .m3u8 URL) directly to the video
    // element through the `src` property. This is using the built-in support
    // of the plain video element, without using hls.js.
    //
    // Note: it would be more normal to wait on the 'canplay' event below however
    // on Safari (where you are most likely to find built-in HLS support) the
    // video.src URL must be on the user-driven white-list before a 'canplay'
    // event will be emitted; the last video event that can be reliably
    // listened-for when the URL is not on the white-list is 'loadedmetadata'.
    else if (videoplayer.canPlayType('application/vnd.apple.mpegurl')) {
      videoplayer.src = videoSrc;
    }
  })

  // live streams: https://vimeo.com/search/page:1?live=now

</script>

<!--
<img alt="bg" src="https://picsum.photos/seed/picsum/1500/1500" />

<video>
  on:loadeddata={ pause }

-->

<div class="videocontainer" class:black style={ styleVars({zIndex, backdropFilter, backdropOpacity}) }>
  <video 
    muted 
    bind:this={videoplayer} 
    autoplay 
    playsinline
    style={styleVars({bgImageUrl: `url(${bgImage})`})}
  >
  </video>
  <!--img aria-hidden="true" src={bgImage} class="bgImage" alt="background image" /-->
</div>

<div class="glow" class:black style={ styleVars({zIndex}) }></div>


<style lang="scss">
  /*img, :global(.videocontainer iframe)*/ .videocontainer {
    height: 100%;
    width: 100%;
    top:0;
    left:0;
    position: fixed;
    display: block;
    z-index: var(--zIndex);

    /*transform: scale(1.5);*/
    /*filter: blur(8px);*/

    &::after {
      content: "";
      width: 100%;
      height: 100%;
      position: absolute;
      top:0;
      left:0;
      opacity: var(--backdropOpacity);
      backdrop-filter: var(--backdropFilter);
      transition: all 1s;
    }

    transition: filter 1s;
    &.black {
      filter: brightness(0);
    }
  }
  video {
    object-fit: cover;
    object-position: center;
    height: 100vh; /* prevent jump in ios safari, otherwise 100% would be same */
    width: 100vw; /* same */
    background-image: var(--bgImageUrl);
    background-position: center;
    background-size: cover;
  }
  //.bgImage {
  //  position: absolute;
  //  top: 0;
  //  left: 0;
  //  object-fit: cover;
  //  object-position: center;
  //  height: 100vh; /* prevent jump in ios safari, otherwise 100% would be same */
  //  width: 100vw; /* same */
  //}

  .glow {
    position: fixed;
    display: none;
    bottom: 0;
    height: 250px;
    width: 100%;
    background: linear-gradient(to bottom, $color-red-transparent 0%, $color-red 100%);
    z-index: var(--zIndex);
  }

  .glow.black {
    display: initial;
  }

</style>